export type MediaType = 'movie' | 'tv' | 'show';

export interface Work {
  id: string;
  title: string;
  titleEn: string;
  type: MediaType;
  genres: string[];
  region: string;
  year: number;
  rating: number;
  views: string;
  viewsCount: number;
  duration: string;
  director: string;
  cast: string[];
  poster: string;
  backdrop: string;
  synopsis: string;
  tags: string[];
  episodes?: string;
  badge?: string;
}

export const works: Work[] = [
  {
    id: 'the-last-lighthouse',
    title: '最后的灯塔',
    titleEn: 'The Last Lighthouse',
    type: 'movie',
    genres: ['剧情', '悬疑'],
    region: '中国大陆',
    year: 2025,
    rating: 9.1,
    views: '1.2亿',
    viewsCount: 1284000,
    duration: '138 分钟',
    director: '陈砚舟',
    cast: ['张景川', '林晚清', '许南'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20lighthouse%20keeper%20standing%20on%20a%20cliff%20at%20dusk%2C%20moody%20teal%20and%20warm%20amber%20light%2C%20rain%20mist%2C%20dramatic%20sky%2C%20atmospheric%20film%20still&width=600&height=850&seq=lastlighthouse-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20film%20still%20of%20a%20solitary%20lighthouse%20on%20rugged%20coastline%20during%20storm%2C%20dramatic%20clouds%2C%20warm%20lantern%20glow%2C%20deep%20blue%20sea%2C%20atmospheric%20lighting&width=1200&height=800&seq=lastlighthouse-backdrop&orientation=landscape',
    synopsis:
      '一场百年难遇的风暴夜，守塔人陆行舟在灯塔日志里发现了一段从未被记录的求救讯号。随着讯号被一点点拆解，他逐渐意识到，二十年前那场「意外」沉船，或许与这座灯塔、与他自己的家族都有牵扯。',
    tags: ['年度悬疑', '海景大片', '家族秘密', '口碑新片'],
    badge: '新上映',
  },
  {
    id: 'midnight-train-to-harbin',
    title: '开往哈尔滨的夜车',
    titleEn: 'Midnight Train to Harbin',
    type: 'movie',
    genres: ['剧情', '公路'],
    region: '中国大陆',
    year: 2024,
    rating: 8.7,
    views: '8632万',
    viewsCount: 863200,
    duration: '121 分钟',
    director: '周听澜',
    cast: ['宋怀之', '柳如烟', '顾北'],
    poster: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20movie%20poster%20of%20a%20snowy%20night%20train%20station%20platform%2C%20warm%20yellow%20lamps%2C%20silhouetted%20traveler%20with%20suitcase%2C%20steam%20and%20snowflakes%2C%20film%20grain&width=600&height=850&seq=harbintrain-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20night%20train%20crossing%20snowy%20northern%20landscape%2C%20warm%20carriage%20windows%2C%20cold%20blue%20winter%20sky%2C%20long%20exposure%20light%20trails&width=1200&height=800&seq=harbintrain-backdrop&orientation=landscape',
    synopsis:
      '两个在陌生城市各自迷路的年轻人，在同一列跨夜火车上相遇。十二小时的旅程里，他们交换了彼此不愿与人提起的往事，也在清晨的站台前，做出了改变各自轨迹的决定。',
    tags: ['公路电影', '冬季治愈', '独立佳作'],
    badge: '口碑佳作',
  },
  {
    id: 'the-silent-code',
    title: '静默代码',
    titleEn: 'The Silent Code',
    type: 'tv',
    genres: ['犯罪', '科幻'],
    region: '中国大陆',
    year: 2025,
    rating: 9.3,
    views: '2.4亿',
    viewsCount: 2412000,
    duration: '共 24 集',
    episodes: '会员更新至 18 集',
    director: '沈亦寒',
    cast: ['陆知远', '苏映白', '程未'],
    poster: 'https://readdy.ai/api/search-image?query=High%20tech%20thriller%20TV%20series%20poster%2C%20dark%20server%20room%20with%20glowing%20amber%20data%20lines%2C%20detective%20silhouette%20in%20foreground%2C%20cinematic%20teal%20shadows&width=600&height=850&seq=silentcode-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20futuristic%20city%20control%20room%20at%20night%2C%20glowing%20amber%20screens%20and%20cool%20teal%20shadows%2C%20technicians%20watching%20data%20streams&width=1200&height=800&seq=silentcode-backdrop&orientation=landscape',
    synopsis:
      '城市的数据中枢连续出现「无来源」指令，刑侦顾问程未与网络安全专家苏映白被迫组成临时搭档。随着调查深入，他们发现所有指令都指向一套二十年前被销毁的预测算法，而这套算法的设计者，正是程未失踪多年的父亲。',
    tags: ['悬疑烧脑', '年度爆款', '科技犯罪', '持续更新'],
    badge: '热播中',
  },
  {
    id: 'grid-bloom',
    title: '格子里的春天',
    titleEn: 'Grid Bloom',
    type: 'tv',
    genres: ['都市', '爱情'],
    region: '中国大陆',
    year: 2024,
    rating: 8.4,
    views: '1.1亿',
    viewsCount: 1104000,
    duration: '共 32 集',
    director: '梁予安',
    cast: ['孟知意', '傅时舟', '黎小满'],
    poster: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20poster%2C%20young%20couple%20in%20a%20bright%20sunny%20apartment%20surrounded%20by%20plants%2C%20soft%20pastel%20light%2C%20cozy%20and%20hopeful%20mood&width=600&height=850&seq=gridbloom-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20warm%20still%20of%20a%20sunlit%20city%20apartment%20with%20plants%2C%20two%20people%20laughing%20by%20a%20window%2C%20soft%20golden%20afternoon%20light&width=1200&height=800&seq=gridbloom-backdrop&orientation=landscape',
    synopsis:
      '住在同一栋旧公寓里的六个年轻人，各自在城市格子里过着不被理解的生活。一次意外的楼顶露台改造计划，让他们从互不相识的陌生人，慢慢变成了彼此生活里的「邻里家人」。',
    tags: ['都市群像', '治愈系', '高分剧集'],
  },
  {
    id: 'one-table-many-stories',
    title: '一桌好戏',
    titleEn: 'One Table, Many Stories',
    type: 'show',
    genres: ['美食', '真人秀'],
    region: '中国大陆',
    year: 2025,
    rating: 9.0,
    views: '9865万',
    viewsCount: 986500,
    duration: '共 12 期',
    episodes: '每周五更新',
    director: '何叙',
    cast: ['白一诺', '程夏', '叶青'],
    poster: 'https://readdy.ai/api/search-image?query=Variety%20show%20poster%2C%20long%20wooden%20table%20filled%20with%20colorful%20regional%20dishes%2C%20warm%20restaurant%20lighting%2C%20smiling%20hosts%2C%20vibrant%20food%20photography&width=600&height=850&seq=onetable-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20lively%20still%20of%20a%20big%20shared%20dinner%20table%20with%20many%20dishes%2C%20warm%20lantern%20lighting%2C%20people%20laughing%20and%20passing%20bowls%2C%20joyful%20documentary%20style&width=1200&height=800&seq=onetable-backdrop&orientation=landscape',
    synopsis:
      '每一期，三位主理人带着一只旧饭盒，走进一座城市，寻找三道正在消失的家常菜。没有复杂赛制，只有一桌热菜、几位手艺人，以及关于「为什么要做饭」的认真对话。',
    tags: ['美食综艺', '慢综艺', '治愈烟火气'],
    badge: '本周上新',
  },
  {
    id: 'the-mountain-sings',
    title: '山河有声',
    titleEn: 'The Mountain Sings',
    type: 'movie',
    genres: ['纪录', '自然'],
    region: '中国大陆',
    year: 2023,
    rating: 9.2,
    views: '4210万',
    viewsCount: 421000,
    duration: '96 分钟',
    director: '叶清和',
    cast: ['旁白：陈叙'],
    poster: 'https://readdy.ai/api/search-image?query=Documentary%20film%20poster%20of%20misty%20mountain%20ridges%20at%20sunrise%2C%20layered%20peaks%2C%20tiny%20hiker%20silhouette%2C%20warm%20amber%20sky%20over%20cool%20blue%20valleys&width=600&height=850&seq=mountainsings-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20breathtaking%20still%20of%20layered%20mountain%20ridges%20at%20dawn%2C%20sea%20of%20clouds%2C%20warm%20sunlight%20on%20peaks%2C%20cinematic%20nature%20documentary%20look&width=1200&height=800&seq=mountainsings-backdrop&orientation=landscape',
    synopsis:
      '四年拍摄、十一座山系、超过两百位在地居民的口述。这部纪录电影以四季为线索，记录中国山地生态的变化，也记录那些守在山里的人如何与自然相处。',
    tags: ['高分纪录片', '自然之美', '口碑之选'],
  },
  {
    id: 'the-lost-arcade',
    title: '失落的街机厅',
    titleEn: 'The Lost Arcade',
    type: 'movie',
    genres: ['动画', '奇幻'],
    region: '日本',
    year: 2024,
    rating: 8.9,
    views: '7634万',
    viewsCount: 763400,
    duration: '112 分钟',
    director: '佐仓真一',
    cast: ['声演：星野澪', '声演：高桥悠'],
    poster: 'https://readdy.ai/api/search-image?query=Anime%20film%20poster%2C%20nostalgic%20dim%20arcade%20hall%20with%20neon%20signs%20and%20pixel%20machines%2C%20a%20young%20girl%20looking%20back%2C%20soft%20nostalgic%20glow%2C%20hand%20drawn%20style&width=600&height=850&seq=lostarcade-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20anime%20still%20of%20a%20nostalgic%20arcade%20hall%20at%20night%2C%20glowing%20neon%20cabinets%2C%20reflective%20floor%2C%20warm%20and%20magical%20atmosphere&width=1200&height=800&seq=lostarcade-backdrop&orientation=landscape',
    synopsis:
      '即将拆除的老街机厅里，只剩最后一台还能启动的机器。女孩小凪在通关那条从未有人走完的关卡后，发现自己可以短暂走进游戏世界——而那里，藏着她童年最好的朋友留下的信。',
    tags: ['动画电影', '怀旧治愈', '高分动画'],
  },
  {
    id: 'deepwater-archive',
    title: '深海档案',
    titleEn: 'Deepwater Archive',
    type: 'tv',
    genres: ['悬疑', '剧情'],
    region: '英国',
    year: 2025,
    rating: 8.8,
    views: '5322万',
    viewsCount: 532200,
    duration: '共 8 集',
    episodes: '全集上线',
    director: 'Alistair Finch',
    cast: ['Eleanor Wise', 'Marcus Hale', 'Iris Nolan'],
    poster: 'https://readdy.ai/api/search-image?query=British%20mystery%20series%20poster%2C%20deep%20sea%20research%20vessel%20corridor%20with%20emergency%20lights%2C%20wet%20metal%20walls%2C%20lone%20divers%20helmet%2C%20cinematic%20cool%20tones&width=600&height=850&seq=deepwater-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20deep%20sea%20research%20platform%20at%20night%20in%20rough%20ocean%2C%20orange%20warning%20lights%2C%20cold%20ocean%20water&width=1200&height=800&seq=deepwater-backdrop&orientation=landscape',
    synopsis:
      '一座位于北海深处的废弃观测站突然恢复供电，并向外传出一段不属于任何人类的低频讯号。海洋地质学家与潜水员组成小队前往调查，却发现记录本最后一页写着他们自己的名字。',
    tags: ['英剧', '深海悬疑', '迷你剧'],
  },
  {
    id: 'sunny-bakery',
    title: '晴日面包房',
    titleEn: 'Sunny Bakery',
    type: 'tv',
    genres: ['治愈', '日常'],
    region: '日本',
    year: 2024,
    rating: 8.6,
    views: '6188万',
    viewsCount: 618800,
    duration: '共 10 集',
    director: '田中晓',
    cast: ['桥本岚', '森下葵'],
    poster: 'https://readdy.ai/api/search-image?query=Japanese%20cozy%20drama%20poster%2C%20small%20neighborhood%20bakery%20with%20warm%20morning%20light%2C%20fresh%20bread%20trays%2C%20wooden%20interior%2C%20soft%20pastel%20colors&width=600&height=850&seq=sunnybakery-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20warm%20still%20of%20a%20small%20bakery%20interior%20at%20morning%2C%20window%20light%2C%20fresh%20bread%20on%20wooden%20counter%2C%20cozy%20everyday%20atmosphere&width=1200&height=800&seq=sunnybakery-backdrop&orientation=landscape',
    synopsis:
      '辞去大公司工作的小满回到海边小镇，接下了外公开了四十年的面包房。每一集都从凌晨四点的第一批面团开始，讲述一位客人的故事，也讲述小满一点点重新爱上自己生活的过程。',
    tags: ['日剧', '深夜治愈', '美食日常'],
  },
  {
    id: 'city-of-rhythm',
    title: '街角节拍',
    titleEn: 'City of Rhythm',
    type: 'show',
    genres: ['音乐', '竞演'],
    region: '中国大陆',
    year: 2024,
    rating: 8.5,
    views: '7731万',
    viewsCount: 773100,
    duration: '共 10 期',
    director: '黎见',
    cast: ['导师：周牧', '导师：林溪'],
    poster: 'https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%2C%20urban%20rooftop%20stage%20at%20night%20with%20warm%20spotlights%2C%20performers%20with%20instruments%2C%20vibrant%20street%20atmosphere&width=600&height=850&seq=cityrhythm-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20energetic%20still%20of%20a%20rooftop%20music%20stage%20at%20dusk%2C%20city%20skyline%20behind%2C%20warm%20amber%20lights%2C%20crowd%20cheering&width=1200&height=800&seq=cityrhythm-backdrop&orientation=landscape',
    synopsis:
      '节目把舞台搬到真实的街角、天台与市场。来自不同城市的十二支乐队，用一首原创作品介绍自己长大的地方。没有淘汰倒计时，只有声音被认真听见的那一刻。',
    tags: ['音乐综艺', '原创舞台', '城市故事'],
  },
  {
    id: 'steel-sky',
    title: '钢之上空',
    titleEn: 'Above the Steel Sky',
    type: 'movie',
    genres: ['科幻', '动作'],
    region: '美国',
    year: 2025,
    rating: 8.3,
    views: '1.6亿',
    viewsCount: 1620000,
    duration: '145 分钟',
    director: 'Nathan Cole',
    cast: ['Ryan Mercer', 'Ada Vaughn', 'Leo Park'],
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20action%20movie%20poster%2C%20futuristic%20floating%20city%20above%20clouds%2C%20lone%20pilot%20silhouette%20against%20orange%20sky%2C%20epic%20scale%2C%20cinematic%20lens%20flare&width=600&height=850&seq=steelsky-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20epic%20sci-fi%20still%20of%20a%20floating%20steel%20city%20above%20the%20clouds%2C%20warm%20orange%20horizon%2C%20immense%20scale%2C%20cinematic%20lighting&width=1200&height=800&seq=steelsky-backdrop&orientation=landscape',
    synopsis:
      '在云层之上的钢铁城市里，维修工卡尔发现城市的地基正在下沉。为了让三十万居民安全着陆，他必须在七十二小时内独自穿越最危险的航道，并重新讲出那个被官方删掉的真相。',
    tags: ['视效大片', '科幻新片', '大银幕推荐'],
    badge: '热议新片',
  },
  {
    id: 'paper-moon-diary',
    title: '纸月日记',
    titleEn: 'Paper Moon Diary',
    type: 'tv',
    genres: ['年代', '剧情'],
    region: '中国台湾',
    year: 2023,
    rating: 9.0,
    views: '4877万',
    viewsCount: 487700,
    duration: '共 16 集',
    director: '陈家砚',
    cast: ['吴念之', '赖时辰', '苏月'],
    poster: 'https://readdy.ai/api/search-image?query=Nostalgic%20period%20drama%20poster%2C%20old%20Taiwan%20street%20with%20paper%20lanterns%20and%20bicycle%2C%20warm%20sepia%20tones%2C%20rain-wet%20pavement&width=600&height=850&seq=papermoon-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20period%20drama%20still%20of%20a%20rainy%20old%20street%20with%20paper%20lanterns%2C%20warm%20shop%20windows%2C%20gentle%20nostalgic%20film%20grain&width=1200&height=800&seq=papermoon-backdrop&orientation=landscape',
    synopsis:
      '一本被三代人反复写满的日记，串联起小镇照相馆六十年的变化。从胶片到底片，从手写到打字机，每一页都记录着普通人在时代里的微小坚持。',
    tags: ['年代剧', '家族故事', '高分推荐'],
  },
  {
    id: 'green-room',
    title: '绿房间',
    titleEn: 'The Green Room',
    type: 'show',
    genres: ['访谈', '文化'],
    region: '中国大陆',
    year: 2025,
    rating: 8.9,
    views: '3956万',
    viewsCount: 395600,
    duration: '共 12 期',
    episodes: '每周三更新',
    director: '庄叙',
    cast: ['主持：叶知'],
    poster: 'https://readdy.ai/api/search-image?query=Talk%20show%20poster%2C%20cozy%20intimate%20studio%20with%20plants%20and%20warm%20lamps%2C%20two%20chairs%20facing%2C%20dark%20green%20walls%2C%20soft%20cinematic%20lighting&width=600&height=850&seq=greenroom-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20still%20of%20an%20intimate%20talk%20show%20set%20with%20green%20walls%2C%20warm%20lamps%2C%20plants%2C%20two%20comfortable%20chairs%2C%20cinematic%20soft%20light&width=1200&height=800&seq=greenroom-backdrop&orientation=landscape',
    synopsis:
      '没有提词器，没有预设问题。每期只邀请一位创作者，在一个摆满绿植的小房间里聊两个小时：关于失败的作品、被放弃的提案，以及那些让人依然愿意继续创作的理由。',
    tags: ['深度访谈', '创作者', '文化综艺'],
  },
  {
    id: 'dune-of-time',
    title: '时间沙丘',
    titleEn: 'Dune of Time',
    type: 'movie',
    genres: ['剧情', '爱情'],
    region: '法国',
    year: 2024,
    rating: 8.7,
    views: '3025万',
    viewsCount: 302500,
    duration: '117 分钟',
    director: 'Camille Laurent',
    cast: ['Élise Moreau', 'Julien Roche'],
    poster: 'https://readdy.ai/api/search-image?query=French%20romantic%20film%20poster%2C%20couple%20walking%20across%20vast%20sand%20dunes%20at%20sunset%2C%20long%20shadows%2C%20warm%20orange%20and%20soft%20rose%20tones%2C%20minimal%20composition&width=600&height=850&seq=dunetime-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20romantic%20still%20of%20two%20figures%20walking%20across%20vast%20dunes%20at%20golden%20hour%2C%20long%20shadows%2C%20warm%20minimalist%20landscape&width=1200&height=800&seq=dunetime-backdrop&orientation=landscape',
    synopsis:
      '一位气象研究员在沙漠观测站工作三年，每年只在同一季节见到同一个人。他们从不说再见，也不问对方的名字，直到某一年，那个人没有来。',
    tags: ['法国电影', '文艺爱情', '获奖影片'],
  },
  {
    id: 'the-quiet-office',
    title: '安静的办公室',
    titleEn: 'The Quiet Office',
    type: 'tv',
    genres: ['职场', '喜剧'],
    region: '中国大陆',
    year: 2025,
    rating: 8.2,
    views: '5420万',
    viewsCount: 542000,
    duration: '共 20 集',
    episodes: '会员抢先看',
    director: '徐照',
    cast: ['王一野', '谭小筑', '何冲'],
    poster: 'https://readdy.ai/api/search-image?query=Workplace%20comedy%20TV%20poster%2C%20bright%20modern%20open%20office%20with%20colorful%20desks%2C%20one%20exaggeratedly%20calm%20employee%2C%20playful%20tone&width=600&height=850&seq=quietoffice-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20bright%20comedic%20still%20of%20a%20modern%20open%20plan%20office%2C%20colorful%20desks%20and%20plants%2C%20playful%20energy%2C%20soft%20daylight&width=1200&height=800&seq=quietoffice-backdrop&orientation=landscape',
    synopsis:
      '一家决定「全面降噪」的公司，要求所有人用纸条和表情包沟通。从实习生到部门总监，这群人在一场场荒诞的规章实验里，慢慢学会了怎么把话说清楚。',
    tags: ['职场喜剧', '轻松下饭', '新剧'],
    badge: '热播中',
  },
  {
    id: 'neon-hunters',
    title: '霓虹追缉',
    titleEn: 'Neon Hunters',
    type: 'movie',
    genres: ['动作', '犯罪'],
    region: '韩国',
    year: 2023,
    rating: 8.1,
    views: '9245万',
    viewsCount: 924500,
    duration: '126 分钟',
    director: 'Park Ji-hoon',
    cast: ['Lee Seo-jin', 'Han Na-ri'],
    poster: 'https://readdy.ai/api/search-image?query=Korean%20action%20thriller%20poster%2C%20rain-soaked%20neon%20night%20street%2C%20detective%20running%20with%20umbrella%2C%20reflective%20asphalt%2C%20warm%20orange%20vs%20dark%20navy&width=600&height=850&seq=neonhunters-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20rain-soaked%20neon%20night%20street%2C%20reflective%20asphalt%2C%20chase%20scene%20motion%2C%20warm%20accents%20over%20dark%20navy&width=1200&height=800&seq=neonhunters-backdrop&orientation=landscape',
    synopsis:
      '连续三起案件的现场，都出现同一段被剪掉的监控画面。追查的老刑警发现，那位总是在现场附近出现的出租车司机，比他更了解这座城市每一条没有灯的小巷。',
    tags: ['动作犯罪', '韩国电影', '夜戏质感'],
  },
  {
    id: 'home-of-clouds',
    title: '云上的家',
    titleEn: 'Home of Clouds',
    type: 'show',
    genres: ['旅行', '生活'],
    region: '中国大陆',
    year: 2023,
    rating: 8.6,
    views: '2865万',
    viewsCount: 286500,
    duration: '共 8 期',
    director: '唐野',
    cast: ['嘉宾：苏禾', '嘉宾：陆时'],
    poster: 'https://readdy.ai/api/search-image?query=Travel%20lifestyle%20show%20poster%2C%20small%20wooden%20cabin%20on%20mountain%20meadow%20with%20clouds%20below%2C%20morning%20mist%2C%20warm%20sunrise&width=600&height=850&seq=homeclouds-poster&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20serene%20still%20of%20a%20small%20cabin%20on%20a%20mountain%20meadow%20above%20clouds%2C%20sunrise%20warmth%2C%20quiet%20travel%20documentary%20mood&width=1200&height=800&seq=homeclouds-backdrop&orientation=landscape',
    synopsis:
      '五组家庭用一整季时间，在海拔两千米的地方共同搭建一间小木屋。从选材到落成，他们和当地木匠一起，把一件慢下来的事，认真做完了。',
    tags: ['旅行综艺', '生活美学', '慢节奏'],
  },
];

export const categoryMeta: Record<MediaType, { name: string; en: string; desc: string; icon: string; cover: string }> = {
  movie: {
    name: '电影频道',
    en: 'Movies',
    desc: '涵盖动作、剧情、科幻、纪录等全类型高清电影资源',
    icon: 'ri-film-line',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20collage%20of%20film%20reels%20and%20theater%20seating%20in%20warm%20amber%20light%2C%20dark%20navy%20background%2C%20elegant%20minimal%20editorial%20photography&width=900&height=600&seq=cat-movie-2026&orientation=landscape',
  },
  tv: {
    name: '剧集频道',
    en: 'TV Series',
    desc: '国产剧、欧美剧、日韩剧持续更新，追剧不迷路',
    icon: 'ri-tv-2-line',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20television%20showing%20abstract%20warm%20orange%20scene%2C%20cozy%20sofa%20and%20soft%20lamp%20light%2C%20minimal%20interior%20photography&width=900&height=600&seq=cat-tv-2026&orientation=landscape',
  },
  show: {
    name: '综艺频道',
    en: 'Variety Shows',
    desc: '美食、音乐、访谈、竞演，生活里最好的下饭节目',
    icon: 'ri-mic-line',
    cover: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20warm%20orange%20spotlights%20and%20studio%20microphone%20in%20foreground%2C%20dark%20blue%20haze%2C%20minimal%20editorial%20photography&width=900&height=600&seq=cat-show-2026&orientation=landscape',
  },
};

export const heroSlides = [
  {
    id: 'the-silent-code',
    kicker: '本周热播 · 悬疑烧脑',
    title: '静默代码',
    subtitle: '当城市开始自己思考，谁在写下一行指令？',
    meta: '2025 · 犯罪科幻 · 更新至 18 集 · 评分 9.3',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20futuristic%20data%20control%20room%20at%20night%2C%20glowing%20amber%20screens%2C%20hero%20silhouette%20watching%20data%20streams%2C%20deep%20navy%20shadows%2C%20dramatic%20film%20still&width=1920&height=1000&seq=hero-silentcode-2026&orientation=landscape',
  },
  {
    id: 'the-last-lighthouse',
    kicker: '年度口碑力作',
    title: '最后的灯塔',
    subtitle: '一场风暴，揭开二十年前被抹去的航路',
    meta: '2025 · 剧情悬疑 · 138 分钟 · 评分 9.1',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20a%20lone%20lighthouse%20on%20a%20cliff%20during%20a%20night%20storm%2C%20warm%20lantern%20beam%20over%20dark%20blue%20ocean%2C%20rain%20and%20mist%2C%20epic%20film%20still&width=1920&height=1000&seq=hero-lighthouse-2026&orientation=landscape',
  },
  {
    id: 'steel-sky',
    kicker: '视效巨制 · 全网热议',
    title: '钢之上空',
    subtitle: '城市正在下沉，而他必须在七十二小时内讲出真相',
    meta: '2025 · 科幻动作 · 145 分钟 · 评分 8.3',
    image: 'https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20banner%20of%20a%20floating%20steel%20city%20above%20a%20sea%20of%20clouds%20at%20sunset%2C%20warm%20orange%20horizon%2C%20tiny%20aircraft%20silhouette%2C%20immense%20scale&width=1920&height=1000&seq=hero-steelsky-2026&orientation=landscape',
  },
  {
    id: 'one-table-many-stories',
    kicker: '慢综艺精选',
    title: '一桌好戏',
    subtitle: '跟着一只旧饭盒，寻找正在消失的家常味道',
    meta: '2025 · 美食真人秀 · 每周五更新 · 评分 9.0',
    image: 'https://readdy.ai/api/search-image?query=Wide%20warm%20banner%20of%20a%20long%20shared%20dinner%20table%20with%20many%20dishes%20under%20lantern%20light%2C%20hands%20passing%20bowls%2C%20joyful%20and%20cozy%20documentary%20film%20still&width=1920&height=1000&seq=hero-onetable-2026&orientation=landscape',
  },
];

export const genreOptions = [
  '全部',
  '剧情',
  '悬疑',
  '犯罪',
  '科幻',
  '爱情',
  '动作',
  '喜剧',
  '动画',
  '纪录',
  '治愈',
  '职场',
  '美食',
  '真人秀',
  '音乐',
  '访谈',
  '年代',
  '公路',
  '自然',
  '奇幻',
  '日常',
  '文化',
  '生活',
  '旅行',
  '竞演',
  '都市',
];

export const regionOptions = ['全部', '中国大陆', '中国台湾', '日本', '韩国', '美国', '英国', '法国'];

export const yearOptions = ['全部', '2025', '2024', '2023', '更早'];

export const sortOptions = ['最新上线', '评分最高', '最多关注'] as const;

export const trendingTags = ['年度悬疑', '高分纪录片', '慢综艺', '治愈系', '视效大片', '科技犯罪'];

export const getWorkById = (id: string): Work | undefined => works.find((item) => item.id === id);

export const getWorksByType = (type: MediaType): Work[] => works.filter((item) => item.type === type);

export const topWorks = [...works].sort((a, b) => b.viewsCount - a.viewsCount).slice(0, 10);

export const latestWorks = [...works].sort((a, b) => b.year - a.year).slice(0, 8);

export const getRelated = (work: Work, limit = 5): Work[] =>
  works
    .filter((item) => item.id !== work.id)
    .map((item) => {
      let score = 0;
      if (item.type === work.type) score += 3;
      score += item.genres.filter((g) => work.genres.includes(g)).length * 2;
      if (item.region === work.region) score += 1;
      if (item.tags.some((t) => work.tags.includes(t))) score += 1;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating)
    .slice(0, limit)
    .map((entry) => entry.item);

export const typeLabel: Record<MediaType, string> = {
  movie: '电影',
  tv: '剧集',
  show: '综艺',
};